import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Checkbox, Collapse, ListItemButton } from "@mui/material";
import { useState } from "react";

const DataCollapse = ({
  colorBackground,
  readonly = false,
  style, 
  checked,
  handleChecked,
  loading,
  Content,
  Header,
  paddingX,
  asList = false,
  variant = 'default'
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const isCashier = variant === 'cashier';

  return<Box
      display='flex'
      flexDirection='column'
      width='100%'
      sx={isCashier ? {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2.5,
        overflow: 'hidden',
        background: '#FFFFFF',
        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)'
      } : undefined}
    > 
      <Box
        display='flex'
        flexDirection='row'
        width='100%'
        sx={isCashier ? { ...style, background: '#FFFFFF' } : style}
        paddingX={paddingX}
      >
        {asList &&<Box>
            <Checkbox disabled={readonly} checked={checked} onChange={handleChecked} />
        </Box>}
        <ListItemButton onClick={handleClick} sx={{ justifyContent: 'space-between', padding: isCashier ? '8px 10px' : '0' }}>
          <Box display='flex' flexDirection='row' width='100%' justifyContent={'space-between'}>
              <Header />
              {/* <ListItemText primary="Inbox" /> */}
              {open ? <ExpandLess /> : <ExpandMore />}
          </Box>
        </ListItemButton>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit sx={{ background: isCashier ? '#F8FAFC' : colorBackground }}>
        {/* <Typography sx={{background: readonly ? styleReadonly.background : colorBackground, color: readonly ? styleReadonly.color : colorFont}} variant='body2' paddingLeft={5}>asdadasd</Typography> */}
        <Content />
      </Collapse>
    </Box>}

export default DataCollapse;
